import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// COR-324: exportação reutilizável para TODOS os épicos do Revisor Contábil — antes deste ponto,
// cada auditoria (Arredondamentos/Ajustes, Caixa, Benefícios Indiretos, Split de Despesas etc.)
// duplicava sua própria função exportarXLSX*/exportarCSV*. A qualidade dos históricos foi o
// primeiro pedido explícito de um recurso ÚNICO e compartilhado ("evitar criar uma exportação
// diferente para cada regra") — novos épicos com grande volume de linhas devem importar daqui em
// vez de duplicar a lógica de escrita do arquivo.

/** Deriva um nome de arquivo seguro (sem espaços/acentos/caracteres especiais) a partir de um texto livre. */
export const nomeArquivoSeguro = (base: string): string => base.replace(/[^\w-]+/g, '_');

/**
 * Exporta uma lista de objetos "achatados" (uma linha = um registro, chaves = cabeçalho) para
 * XLSX. Cada objeto deve ter as MESMAS chaves, na ordem em que devem aparecer nas colunas.
 */
export function exportarXLSX<T extends Record<string, string | number>>(
  linhas: T[],
  nomeArquivo: string,
  nomeAba = 'Dados'
): void {
  if (linhas.length === 0) return;
  const ws = XLSX.utils.json_to_sheet(linhas);
  const wb = { Sheets: { [nomeAba]: ws }, SheetNames: [nomeAba] };
  const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });
  saveAs(blob, `${nomeArquivo}.xlsx`);
}

/** Mesma lista de objetos, exportada como CSV (separador ";", BOM UTF-8 para abrir corretamente no Excel). */
export function exportarCSV<T extends Record<string, string | number>>(
  linhas: T[],
  nomeArquivo: string
): void {
  if (linhas.length === 0) return;
  const cabecalho = Object.keys(linhas[0]);
  const corpo = linhas.map(linha => Object.values(linha));
  const csv = [cabecalho, ...corpo]
    .map(row => row.map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(';'))
    .join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `${nomeArquivo}.csv`);
}
